import React from "react";
import CTA from "./CTA";
import Service from "./Service";
import styles from "./Services.module.css";

interface ServicesProps {
  contact: React.RefObject<HTMLElement | null>;
}

const Services = React.forwardRef<HTMLElement, ServicesProps>(
  ({ contact }, ref) => {
    const handleContactClick = () => {
      contact.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    };

    return (
      <section
        ref={ref}
        id={`services_${React.useId()}`}
        className={styles.services}
      >
        <div className={styles.content}>
          <div className={styles.header}>
            <h2 className={styles.title}>What We Do</h2>
            <p className={styles.subtitle}>
              We partner with organizations to build exceptional software
              solutions that drive business growth and innovation.
            </p>
          </div>

          <div className={styles.list}>
            <Service
              icon="development"
              title="Custom Software Development"
              features={[
                "Full-stack web applications",
                "RESTful API development",
                "Database design & optimization",
                "Third-party integrations",
              ]}
            >
              End-to-end development of web applications, REST APIs, and
              enterprise software solutions using modern technologies including
              TypeScript, React, and Node.js.
            </Service>

            <Service
              icon="cloud"
              title="Cloud Infrastructure"
              features={[
                "AWS deployment & management",
                "Docker containerization",
                "CI/CD pipeline setup",
                "Infrastructure automation",
              ]}
            >
              Scalable, secure cloud solutions on AWS with containerization,
              automated deployments, and infrastructure as code practices.
            </Service>

            <Service
              icon="consulting"
              title="Technical Consulting"
              features={[
                "System architecture design",
                "Code reviews & audits",
                "Technology strategy",
                "Performance optimization",
              ]}
            >
              Strategic technology guidance, architecture reviews, and technical
              leadership to help organizations make informed decisions.
            </Service>
          </div>

          <CTA onClick={handleContactClick} />
        </div>
      </section>
    );
  },
);

Services.displayName = "Services";

export default Services;
